import { Assets } from 'pixi.js';

/** Buy-bonus expanding-wild badges in `/assets/multipliers`. */
const MULTIPLIER_TEXTURE_URL = {
  2: '/assets/multipliers/2x_multiplier.png',
  3: '/assets/multipliers/3x_multiplier.png',
  5: '/assets/multipliers/5x_multiplier.png',
  10: '/assets/multipliers/10x_multiplier.png',
};

/** @type {Map<number, import('pixi.js').Texture>} */
const textures = new Map();

/** @type {Promise<void> | null} */
let loadPromise = null;

export function preloadWildMultiplierTextures() {
  if (!loadPromise) {
    loadPromise = (async () => {
      await Promise.all(
        Object.entries(MULTIPLIER_TEXTURE_URL).map(async ([key, url]) => {
          try {
            const tex = await Assets.load(url);
            if (tex) textures.set(Number(key), tex);
          } catch (error) {
            console.warn(`Failed to load wild multiplier badge ${key}:`, error);
          }
        }),
      );
    })();
  }
  return loadPromise;
}

/**
 * @param {number} multiplier
 * @returns {import('pixi.js').Texture | null}
 */
export function getWildMultiplierTexture(multiplier) {
  return textures.get(Math.round(Number(multiplier))) ?? null;
}
